import { RestaurantModel } from '../../models';
import { MQTTCredentials } from '../../types/mqttCredentialsType';
import { mqtt, iot } from 'aws-iot-device-sdk-v2';
import { hideToast, showErrorToast } from '../toaster';
import i18n from '../../localization/i18n';
import { reloadPage } from '../../helpers/reloadPage';
import queryClient from '../query/queryClient';
import getTopicsMap from './getTopicsMap';
import { v4 as uuidv4 } from 'uuid';

let connection: mqtt.MqttClientConnection | null = null;
let connectionFailures = 0;

const handleConnectionError = () => {
    showErrorToast(i18n.t('orders.live_orders_messages.main.please_try_later'), {
        autoClose: false,
        ctaButtonText: i18n.t('orders.live_orders_messages.main.reload_page'),
        onCtaButtonClick: reloadPage,
        toastId: 'connection-error'
    });
};

const listenToRestaurantEvents = (restaurant: RestaurantModel) => {
    const topicsMap = getTopicsMap(restaurant);

    for (const [topic, qos, callback] of topicsMap) {
        connection?.subscribe(topic, qos, callback);
    }
};

const listenToConnectionEvents = () => {
    connection?.on('connection_failure', () => {
        connectionFailures++;
        if (connectionFailures === 5) {
            handleConnectionError();
            connection?.disconnect();
        }
    });
    connection?.on('resume', () => {
        queryClient.invalidateQueries();
        hideToast('connection-error');
        connectionFailures = 0;
    });
};

export const connect = async (restaurant: RestaurantModel, mqttCredentials: MQTTCredentials) => {
    const uuid = uuidv4();
    const config = iot.AwsIotMqttConnectionConfigBuilder.new_default_builder()
        .with_clean_session(false)
        .with_client_id(`live-orders_${restaurant.reference}_${uuid}`)
        .with_endpoint(mqttCredentials.Host)
        .with_custom_authorizer(
            '',
            mqttCredentials.CustomAuthorizerName,
            mqttCredentials.Signature,
            '',
            mqttCredentials.TokenKeyName,
            mqttCredentials.Token
        )
        .with_keep_alive_seconds(30)
        .build();

    if (connection) {
        await connection.disconnect();
    }

    const client = new mqtt.MqttClient();

    connection = client.new_connection(config);

    listenToConnectionEvents();

    await connection.connect();

    listenToRestaurantEvents(restaurant);
};

export const disconnect = async () => {
    if (connection) {
        await connection.disconnect();
    }
};
